import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[appColumnHost]'
})
export class ColumnHostDirective {

  constructor(public viewContainerRef: ViewContainerRef) { }

}
